import { NAME } from './constants';

export const SUBMIT_LOGIN_FORM = `${NAME}.SUBMIT_LOGIN_FORM`;
